module.exports = __webpack_public_path__ + "static/media/label-icon-importance.bd3293f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/label-icon-importance.svg
// module id = 1869
// module chunks = 0